let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kCTMZ"), load("bKdog"), load("aZinD"), load("6qah4"), load("dGFK7")]).then(() => parcelRequire('gxWFp'));